import script from "./ButtonLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonLoading.vue?vue&type=script&setup=true&lang=js"

import "./ButtonLoading.vue?vue&type=style&index=0&id=84ce5b6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84ce5b6c"]])

export default __exports__